<template>
  <main class="main-content">
    <component :is="NavItem"></component>
  <div class="product-setup-container">
    <div class="header">
      <div class="icon">
        <img src="/img/icons/product.png" alt="Product Setup" class="product-icon">
      </div>
      <h1>Product Setup</h1>
    </div>

    <div class="table-container">
      <table class="product-table">
        <thead>
        <tr>
          <th>Name</th>
          <th>Interest</th>
          <th>Rev Bonus</th>
          <th>Ter Bonus</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(plan, index) in plans" :key="index">
          <td>{{ plan.name }}</td>
          <td>{{ plan.interest }}</td>
          <td>{{ plan.revBonus }}</td>
          <td>{{ plan.terBonus }}</td>
          <td>
              <span class="status-badge" :class="plan.status.toLowerCase()">
                {{ plan.status }}
              </span>
          </td>
          <td class="action-buttons">
            <button class="btn-edit" @click="editProduct(plan)">Edit</button>
            <button class="btn-duplicate">Duplicate</button>
            <button class="btn-delete">Delete</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div class="rows-per-page">
        <span>Rows per page:</span>
        <select v-model="rowsPerPage">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
        </select>
      </div>
      <div class="page-info">1-10 of 100</div>
      <div class="page-controls">
        <button class="prev-page"><i class="fas fa-chevron-left"></i></button>
        <button class="next-page"><i class="fas fa-chevron-right"></i></button>
      </div>
    </div>
  </div>
  </main>
</template>

<script>
import NavItem from '@/admin/components/nav/NavItem.vue';
import EditProduct from '@/admin/components/EditProduct.vue';

export default {
  name: 'ProductSetup',
  components: { NavItem, EditProduct },
  computed: {
    NavItem() {
      return NavItem;
    },
  },
  data() {
    return {
      rowsPerPage: 10,
      plans: [
        {
          name: 'Akiba halisi plan',
          interest: 'Def 10%',
          revBonus: 'Def 10%',
          terBonus: 'Def 10%',
          status: 'Active',
        },
        {
          name: 'Elimu education plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'In-active',
        },
        {
          name: 'Individual pension plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Pumzisha last exp plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Term assurance plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Wealth builder plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Akiba halisi plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Whole life plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Imarika plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
        {
          name: 'Key man plan',
          interest: 'Min 7%',
          revBonus: 'Min 60%',
          terBonus: 'Min 30%',
          status: 'Active',
        },
      ],
    };
  },
  methods: {
    editProduct() {
      this.$emit('change-component', EditProduct);
    },
  },
};
</script>

<style scoped>
.product-setup-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 20px;
  max-width: 100%;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.icon {
  background-color: #0047CC;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.product-icon {
  width: 28px;
  height: 28px;
    filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7462%) hue-rotate(236deg) brightness(113%) contrast(101%);
}

h1 {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
}

.product-table th {
  background-color: #f9f9f9;
  color: #555;
  font-weight: 500;
  text-align: left;
  padding: 12px 16px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
}

.product-table td {
  padding: 16px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #333;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.active {
  background-color: #e6f7e6;
  color: #28a745;
}

.in-active {
  background-color: #ffe6e6;
  color: #dc3545;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-edit {
  color: #0047CC;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}

.btn-duplicate {
  color: #0047CC;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}

.btn-delete {
  color: #ff6b6b;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.rows-per-page {
  display: flex;
  align-items: center;
  margin-right: 24px;
}

.rows-per-page span {
  margin-right: 8px;
}

.rows-per-page select {
  padding: 4px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}

.page-info {
  margin-right: 24px;
}

.page-controls {
  display: flex;
  gap: 8px;
}

.page-controls button {
  width: 32px;
  height: 32px;
  border: 1px solid #ddd;
  background-color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.page-controls button:hover {
  background-color: #f5f5f5;
}
.main-content {
  flex: 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: #f0f2f5;
  left: 16%;
  margin-top: 4%;
  width: 100%;
}
</style>
